import React from 'react'
import { useMemo } from 'sb-hooks'
import cx from 'classnames'
import { array } from 'common/helpers'

import Note from './Note/Note'
import s from './NotesSection.scss'


type NotesSectionProps = {
  className?: string
  noteClassName?: string
  notes: Array<{
    id: number
    name: string
    image: string
    slug: string
    to?: string
  }>
  activeNoteId?: number
  noteImageWidth?: number
}


const NotesSection: React.FunctionComponent<NotesSectionProps> = (props) => {
  const { className, noteClassName, notes, activeNoteId, noteImageWidth } = props

  // show only first 5 notes including activeNote
  const items = useMemo(
    () => {
      const activeNoteIndex = activeNoteId ? notes.findIndex((item) => item.id === activeNoteId) : -1

      return activeNoteIndex > 4 ? (notes.slice(0, 3)).concat(notes[activeNoteIndex]) : notes.slice(0, 5)
    },
    [ notes, activeNoteId ]
  )

  const listClassName = cx(s.notesList, className)
  const composedNoteClassName = cx(s.note, noteClassName)

  return (
    <div className={listClassName} role="list">
      {
        array.range(0, 4)
          .map((index) => {
            if (!items[index]) {
              return <div key={`empty-${index}`} className={composedNoteClassName} />
            }

            const { id, name, image, to } = items[index]
            const isActive = id === activeNoteId

            return (
              <Note
                key={id}
                className={composedNoteClassName}
                name={name}
                image={image}
                imageWidth={noteImageWidth}
                to={to}
                isActive={isActive}
              />
            )
          })
      }
    </div>
  )
}


export default React.memo(NotesSection)
